export default __webpack_public_path__ + "static/media/main-logo.cdfc22f0.svg";